module.exports = __webpack_public_path__ + "static/header-img-1bae788d31e07d465c45f4e18fd436b2.png";